import React from "react";
import { TextField } from "@mui/material";
import GroupAllUsers from "../FieldTags/GroupAllUsers";
import pullListLabels from "../../util/PullListLabels";
import HistoryLogElement from "./HistoryLogElement";

const InformedConsentComment = ({ informedConsentComment, handleChange, shipmentFromRepo, pullLists, required }) => {
    return (
        <div className="planField">
            <GroupAllUsers />
            <TextField
                id="informedConsentComment-field"
                name="informedConsentComment"
                label={shipmentFromRepo === "Yes" ? pullListLabels.informedConsentComment : pullListLabels.disposalRequestComment}
                InputLabelProps={{ shrink: true }}
                type="text"
                required={required.includes("informedConsentComment")}
                value={informedConsentComment ? informedConsentComment  : ""}
                onChange={(e) => handleChange("informedConsentComment", e.target.value)}
                multiline
                minRows={1}
                className="fullLength"
            />
            <HistoryLogElement pullLists={pullLists} label={"informedConsentComment"} />
        </div>
    );
};

export default InformedConsentComment;